import React from "react";

import config from "../../../config/config";

import "./ReferenceTables.scss";

const ReferenceTables2026 = () => {

  if (process.env.REACT_APP_BUILD === "production")
  {
    return ("This chapter is currently not available")
  }

  return (
    <>
      <h1>Reference Tables</h1>
      <section className="ref-tables-section">
        <ul>
          <li>
            <span className="ref-tables-volume">Volume 1 - CKD:</span>
            <ul>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=CKD_Ref_B_Prevalence_2026`}
                >
                  B. Prevalence
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=CKD_Ref_K_Expenditures_2026`}
                >
                  K. Expenditures
                </a>
              </li>
               <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=CKD_Ref_O_Drug_2026`}
                >
                  O. Drug
                </a>
              </li>
            </ul>
          </li>
          <li>
            <span className="ref-tables-volume">Volume 2 - ESKD:</span>
            <ul>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_A_Incidence_2026`}
                >
                  A. Incidence
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_B_Prevalence_2026`}
                >
                  B. Prevalence
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_C_PatientChars_2026`}
                >
                  C. Patient Characteristics
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_D_Modality_2026`}
                >
                  D. Treatment Modalities
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_E_TransplantProcess_2026`}
                >
                  E. Transplantation: Process
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_F_TransplantOutcomes_2026`}
                >
                  F. Transplantation: Outcomes
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_G_Hospitalization_2026`}
                >
                  G. Morbidity and Hospitalization
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_H_Mortality_2026`}
                >
                  H. Mortality and Causes of Death
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_I_Survival_2026`}
                >
                  I. Patient Survival
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_J_Providers_2026`}
                >
                  J. Provider Characteristics
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_K_Costs_2026_all`}
                >
                  K. Expenditures for ESKD Patients (All)
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_K_Costs_2026_DualEligible`}
                >
                  K.S1. Expenditures for ESKD Patients (Dual Eligible)
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_K_Costs_2026_MedicareOnly`}
                >
                  K.S2. Expenditures for ESKD Patients (Medicare Only)
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_L_VascularAccess_2026`}
                >
                  L. Vascular Access
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_M_Census_2026`}
                >
                  M. Census Populations
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_N_International_2026`}
                >
                  N. International Comparisons
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=ESKD_Ref_O_Drug_2026`}
                >
                  O. Drug
                </a>
              </li>
              <li>
                <a
                  href={`${config.baseUri}/referenceTables?year=2026&referenceTable=Reference_Table_Methods`}
                >
                  Analytical Methods
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </section>
    </>
  );
};

export default ReferenceTables2026;